import React from "react";
import { Link } from "gatsby";
import yaml from "js-yaml";
import marked from "marked";

import '../../styles/resources/resources-grid-cell.scss';

class ResourcesGridCell extends React.Component {
  constructor(props) {
    super(props);

    this.formattedHeadline = marked(props.headline).replace('<p>', '').replace('</p>', '');

    try {
      this.links = yaml.load(props.links);
    } catch (e) {
      this.links = null;
      console.log(e);
    }

    this.buildEssayLinkContent = this.buildEssayLinkContent.bind(this);
    this.formattedEssayLinks = this.buildEssayLinkContent(props.essays)
  }

  buildEssayLinkContent() {
    if (this.props.essays.length === 0) {
      return null;
    }

    const listHeader = (this.props.essayContext) ? 'Also Cited in…' : 'Cited in…';

    const essays = (this.props.essayContext) ? this.props.essays.filter(essay => {
      return essay.data.Slug !== this.props.essayContext;
    }) : this.props.essays;

    return (essays.length > 0) ? (
      <div className="resources-grid__citations">
        <p>{listHeader}</p>
        <ul>
          {essays.map((essay, idx) => (
            <li key={idx}>
              <Link to={`/essay/${essay.data.Slug}`}>{essay.data.Title}</Link>
            </li>
          ))}
        </ul>
      </div>
    ) : null;
  }
  
  formatLink(link, idx) {
    const formattedLabel = marked(link.label).replace('<p>', '').replace('</p>', '');

    return (
      <li key={idx}>
        <a href={link.url} target="_blank" rel="noopener noreferrer">{formattedLabel}</a>
        {(link.note) ?
          <span
            className="note"
            dangerouslySetInnerHTML={{ __html: marked(link.note).replace('<p>', '').replace('</p>', '') }}
          />
        : null}
      </li>
    );
  }

  render() {
    const creator = this.props.creator;
    const illustrator = this.props.illustrator;
    const year = this.props.year;
    const category = this.props.category;
    const notes = this.props.notes;

    return (
      <li className="resources-grid__cell">
        <div className="resources-grid__title" dangerouslySetInnerHTML={{__html: this.formattedHeadline}} />
        {(creator || year) ? (
          <div className="resources-grid__meta">
            {creator && (
              <span
                dangerouslySetInnerHTML={
                  { __html: marked(creator).replace('<p>', '').replace('</p>', '')}
                }
              />
            )}
            {illustrator && (
              <span
                dangerouslySetInnerHTML={
                  { __html: marked(illustrator).replace('<p>', '').replace('</p>', '')}
                }
              />
            )}
            {(year) ? (<span>{year}</span>) : null}
          </div>
        ) : null}
        {(notes) ? (
          <div dangerouslySetInnerHTML={{__html: marked(notes)}} />
        ) : null}
        {(this.links) ? (
          <div className="resources-grid__links">
            <ul>
              {this.links.map((link, idx) => this.formatLink(link, idx))}
            </ul>
          </div>
        ) : null}
        {this.buildEssayLinkContent()}

        {(category) ? (
          <div className="resources-grid__category-tag">
            <span className="label">{category}</span>
          </div>
        ) : null}
      </li>
    );
  }
}

export default ResourcesGridCell;